module.exports = __webpack_public_path__ + "static/fonts/SFProDisplay-Light.4ef9fde.woff";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fonts/SFProDisplay-Light/SFProDisplay-Light.woff
// module id = MMCC
// module chunks = 17